














































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ListMixin from '@/components/mixin/list-mixin';
import { mixins } from 'vue-class-component';
import sessionColumns from './handoversession-columns';
class  PageHandoverSessionRequest extends PageRequest{
    keyword:string;
    refTypeCode: string;
    status: string;
    clientCode: string;
    tplCode:string; 
}
@Component({
   components:{}
})
export default class HandoverSession extends mixins(ListMixin, AbpBase){
    namespace = 'handoverSession';
    pagerequest:PageHandoverSessionRequest=new PageHandoverSessionRequest();
    spinShow:boolean=false;
    sessionTypes =[];
    sessionStatuses = [];
    clients=[];
    tpls=[];
     get store () {
      return this.$store.state.handoverSession;
    }
    isTenant() {
      return this.$store.state.session.tenant != null;
    }
    getSessionTypes(){
        var re=  this.$store.state.handoverSession.sessionTypes;
        this.pagerequest.refTypeCode = re.length === 0 ? "" : re[0].code;
        this.sessionTypes= re;
    }
    getSessionStatuses(){
        var re = this.$store.state.handoverSession.sessionStatuses;
        this.pagerequest.status = re.length === 0 ? "" : re[0].code;
        this.sessionStatuses = re;
    }
    getClients(){
         var re = this.$store.state.client.clientsForSelect;
        this.clients= re;
    }
     getTpls(){
        var re = this.$store.state.tpl.tplsForSelect;
        this.pagerequest.tplCode = re.length === 0 ? "" : re[0].id;
        this.tpls= re;
    }
    isRefTypeClient()
    {
      return this.pagerequest.refTypeCode == AppConsts.refType.Client;
    }
    isRefTypeTpl()
    {
      return this.pagerequest.refTypeCode == AppConsts.refType.Tpl;
    }
    viewSession(id:string)
    {
        this.$root.$router.push({path: '../grppicklist/view-handoversession/'+id})
    }
    createSession()
    {
        this.$root.$router.push({path: '../grppicklist/create-handoversession'})
    }
    editSession(id:string)
    {
        this.$root.$router.push({path: '../grppicklist/update-handoversession/'+id})
    }
    get list(){
      var re = this.$store.state.handoverSession.list;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var index = 0;
      re.forEach(function(item) {
        item.orderNo = startIndex + index + 1;
        index++;
      });
      return re;
    }
    preGetPage () {
      if (!this.isRefTypeClient())
      {
        this.pagerequest.clientCode = "";
      }
      if (!this.isRefTypeTpl())
      {
        this.pagerequest.tplCode="";
      }
    }
    columns= sessionColumns
    async created(){
      this.spinShow= true;
      this.refreshListData();
      try {
         await this.$store.dispatch({
            type:'handoverSession/getSessionTypes'
        }).then(()=>{
          this.getSessionTypes();
        });
        await this.$store.dispatch({
            type:'handoverSession/getSessionStatuses',
             data: { hasAllItem: true}
        }).then(()=>{
          this.getSessionStatuses();
        });
         await this.$store.dispatch({
            type:'tpl/getListForSelect',
             data: { hasAllItem: true}
        }).then(()=>{
          this.getTpls();
        });
        this.spinShow = false;
      } catch (error) {
        this.spinShow=false;
      }
       
    }
}
